
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tech-requirements",
      function () {
        return require("private-next-pages/tech-requirements/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tech-requirements"])
      });
    }
  